import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	openInNewTab: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.common.footer.open-in-new-tab',
		defaultMessage: 'Open in new tab',
		description: 'Text of the link which opens the report in a new tab',
	},
	viewInJira: {
		id: 'portfolio-3-portfolio.app-confluence-macro.main-new.common.footer.view-in-jira',
		defaultMessage: 'Open in Plans',
		description: 'Text of the link which opens the plan in Jira',
	},
});

export default messages;
